var script = {
    name: 'Row',
    render() {
        return null;
    }
};

export { script as default };
